import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "col-md-2" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "p-3 d-flex justify-content-end align-items-center price-display" }
const _hoisted_7 = {
  class: "bi bi-info-circle",
  tabindex: "0",
  role: "button",
  "aria-label": "Info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PricingStrategyNameDaysComponent = _resolveComponent("PricingStrategyNameDaysComponent")!
  const _component_UtilizationPricingSettings = _resolveComponent("UtilizationPricingSettings")!
  const _component_PriceUnitComponent = _resolveComponent("PriceUnitComponent")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.currentStrategy.isMultipleWindows)
        ? (_openBlock(), _createBlock(_component_PricingStrategyNameDaysComponent, {
            key: 0,
            name: _ctx.windowProp.name,
            description: _ctx.windowProp.description,
            daysIn: _ctx.windowProp.daysIn,
            daysOut: _ctx.windowProp.daysOut,
            invalidDaysIn: _ctx.invalidDaysIn(_ctx.windowProp.id),
            invalidDaysOut: _ctx.invalidDaysOut(_ctx.windowProp.id),
            daysInMoreThanDayOut: _ctx.daysInMoreThanDayOut(_ctx.windowProp.id),
            invalidName: _ctx.invalidName(_ctx.windowProp.id),
            onUpdateWindow: _ctx.handleUpdateWindowProp
          }, null, 8, ["name", "description", "daysIn", "daysOut", "invalidDaysIn", "invalidDaysOut", "daysInMoreThanDayOut", "invalidName", "onUpdateWindow"]))
        : _createCommentVNode("", true),
      (_ctx.currentStrategy.isAdjustByUtilization)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_UtilizationPricingSettings, {
              ref: (el) => { _ctx.$emit('update:dailyUtilizationSettingsRef', el as ComponentPublicInstance | null) },
              "initial-data": _ctx.utilizationPricesByWindowId[_ctx.windowProp.id ?? 0],
              "is-all-day": false,
              "price-window-id": _ctx.windowProp.id ?? 0,
              onSaveSuccess: _ctx.handlePricingSaveSuccess,
              onSaveError: _ctx.handlePricingSaveError
            }, null, 8, ["initial-data", "price-window-id", "onSaveSuccess", "onSaveError"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfWeek, (day) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row mb-4 price-display",
                key: day.value
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("strong", null, _toDisplayString(day.name), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", null, "Display at", -1)),
                    _createVNode(_component_PriceUnitComponent, {
                      value: _ctx.getUtilizationPrice(_ctx.windowProp.id ?? 0, day.value),
                      isPercent: _ctx.getUsePercent(_ctx.windowProp.id ?? 0, day.value),
                      "onUpdate:value": ($event: any) => (
                  _ctx.updateUtilizationPrice(_ctx.windowProp.id ?? 0, day.value, $event)
                ),
                      "onUpdate:isPercent": ($event: any) => (
                  _ctx.updateUsePercent(_ctx.windowProp.id ?? 0, day.value, $event)
                )
                    }, null, 8, ["value", "isPercent", "onUpdate:value", "onUpdate:isPercent"]),
                    _withDirectives(_createElementVNode("i", _hoisted_7, null, 512), [
                      [_directive_tooltip, {
                  content:
                    'When applying this strategy:<br>If % is selected, a booking channel\'s pricing will be shown as this percentage of the regular rate.<br>If $ is selected, this amount will be shown.',
                  placement: 'top',
                  triggers: ['hover', 'focus'],
                  html: true,
                  popperClass: 'custom-tooltip',
                }]
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]))
    ])
  ]))
}